import { Themes } from '@sainsburys-tech/bolt'
import { ArgosVocab, HabitatVocab, TuVocab } from '@sainsburys-tech/bolt-vocab-provider'
import pkg from '../../package.json'

// This file is used by both the client and the server.
// Do not include API keys or server functions, as these will be included in the client bundle.

const boltUiVersion = pkg.dependencies['@sainsburys-tech/boltui-style'].replace('^', '')

export default {
  argos: {
    key: 'argos',
    salesChannel: 'argos',
    canonicalBase: 'https://www.argos.co.uk',
    faviconPath: '/i/Argos/ArgosFavicon',
    tealiumPath: 'argos/main/qa',
    theme: Themes.ArgosTheme,
    vocab: ArgosVocab,
    bolt: {
      namespace: 'bolt-v2',
      stylesheet: `//www.argos.co.uk/assets/bolt2/${boltUiVersion}/bolt.min.css`
    },
    features: {
      taxonomy: {
        vocabId: ''
      },
      addToTrolley: {
        modal: {
          enabled: true,
          hideExtras: false,
          hideCategories: false
        }
      },
      backInStock: {
        enabled: true
      },
      bestSellers: {
        enabled: true
      },
      sponsoredProducts: {
        enabled: true
      },
      wishlist: {
        enabled: true
      },
      appExclusiveProducts: {
        enabled: true,
        skusAndLinks: {
          '3063037':
            'https://argos.onelink.me/ID6P?af_xp=custom&pid=argos_app_exclusive&c=app-exclusive-oct2025-3063037&deep_link_value=product%2F3063037&af_dp=argos%3A%2F%2F&af_web_dp=http%3A%2F%2Fargos.co.uk%2Fevents%2Fargos-app%3Fcmpid%3Dappsflyer%26utm_source%3Donelink%26utm_campaign%3Dapp_exclusive'
        }
      },
      productList: {
        forceClothingTemplate: false,
        forceEnableAltImageHover: false,
        disableComRel: false,
        enableSortbyNew: true,
        includeRelevancyNewness: false
      },
      productCard: {
        colorSwatchInline: true,
        colorSwatchAlwaysVisible: false,
        colorSwatchMaxVariations: 4,
        colorSwatchSize: 'small',
        showClearanceBadge: true,
        enableValueMessaging: true,
        disableClickPR: false
      },
      detailAttributesWhiteGoods: [
        'Size (cm)',
        'Frozen Food Capacity (Litre)',
        'Frost free',
        'Maximum spin speed (rpm)',
        'Number of programmes',
        'Wash and Dry Cycle Capacity (kg)',
        'Precise wash capacity (kg)',
        'Dryer type',
        'Drying capacity (kg)',
        'Place settings'
      ],
      listerTools: {
        hideMobileResultsCount: false,
        offsetSelector: null,
        safeZone: 375,
        reverseScrollBehaviour: false
      },
      seoFooter: {
        hideOnAppliedFilters: true
      },
      categoryList: {
        contentAreaNav: true
      },
      filterPanel: {
        transposeCategories: []
      },
      filterPills: {
        enabled: false,
        filters: {
          browse: [],
          search: [],
          default: []
        }
      },
      goInStoreWidget: {
        enabled: false
      },
      availability: {
        enabled: true,
        chunkSize: 6,
        hasLocalisationHeader: true,
        webChannel: 'web_plp',
        radius: {
          radiusDefaultValue: 10,
          radiusOptions: [
            { title: '1 mile', value: 1 },
            { title: '3 miles', value: 3 },
            { title: '5 miles', value: 5 },
            { title: '10 miles', value: 10 },
            { title: '15 miles', value: 15 },
            { title: '20 miles', value: 20 },
            { title: '25 miles', value: 25 }
          ],
          radiusLocalStorageKey: 'availability-radius'
        }
      },
      availabilityTooltip: {
        enabled: true
      },
      refinedTitlePage: {
        enabled: true,
        maxRefinements: 2,
        useRefinementTypeConfig: true,
        excludedParentCategoryIds: ['65875'] // Don't apply refinements for direct child categories for this ID (Toy Promotions)
      },
      citrus: {
        banners: {
          enabled: true
        },
        gridBanners: {
          enabled: true
        }
      },
      similarAi: {
        enabled: true,
        routes: ['/sd/', '/browse/']
      },
      brandLogos: false
    }
  },
  habitat: {
    key: 'habitat',
    salesChannel: 'habitat',
    canonicalBase: 'https://www.habitat.co.uk',
    faviconPath: '/i/Argos/HabitatFavicon',
    tealiumPath: 'argos/habitat/qa',
    theme: Themes.HabitatTheme,
    vocab: HabitatVocab,
    bolt: {
      namespace: 'bolt-habitat',
      stylesheet: `//www.argos.co.uk/assets/bolt2/${boltUiVersion}/bolt-habitat.min.css`
    },
    features: {
      taxonomy: {
        vocabId: 'PROD Habitat Navigation'
      },
      addToTrolley: {
        modal: {
          enabled: true,
          hideExtras: true,
          hideCategories: true
        }
      },
      backInStock: {
        enabled: false
      },
      bestSellers: {
        enabled: false
      },
      sponsoredProducts: {
        enabled: false
      },
      wishlist: {
        enabled: false
      },
      productList: {
        forceClothingTemplate: false,
        forceEnableAltImageHover: false,
        disableComRel: false,
        enableSortbyNew: true,
        includeRelevancyNewness: false
      },
      productCard: {
        colorSwatchInline: true,
        colorSwatchAlwaysVisible: false,
        colorSwatchMaxVariations: 4,
        colorSwatchSize: 'small',
        showClearanceBadge: true,
        enableValueMessaging: true,
        disableClickPR: false
      },
      listerTools: {
        hideMobileResultsCount: false,
        offsetSelector: null,
        safeZone: 375,
        reverseScrollBehaviour: false
      },
      seoFooter: {
        hideOnAppliedFilters: false
      },
      categoryList: {
        contentAreaNav: true
      },
      filterPanel: {
        transposeCategories: []
      },
      filterPills: {
        enabled: false,
        filters: {
          browse: [],
          search: [],
          default: []
        }
      },
      goInStoreWidget: {
        enabled: true
      },
      availability: {
        enabled: true,
        chunkSize: 6,
        hasLocalisationHeader: true,
        webChannel: 'web_plp',
        radius: {
          radiusDefaultValue: 10,
          radiusOptions: [
            { title: '1 mile', value: 1 },
            { title: '3 miles', value: 3 },
            { title: '5 miles', value: 5 },
            { title: '10 miles', value: 10 },
            { title: '15 miles', value: 15 },
            { title: '20 miles', value: 20 },
            { title: '25 miles', value: 25 }
          ],
          radiusLocalStorageKey: 'availability-radius'
        }
      },
      availabilityTooltip: {
        enabled: true
      },
      refinedTitlePage: {
        enabled: false,
        maxRefinements: 3,
        refinementTypes: [],
        departments: []
      },
      citrus: {
        banners: {
          enabled: false
        },
        gridBanners: {
          enabled: false
        }
      },
      similarAi: {
        enabled: true,
        routes: ['/sd/', '/browse/']
      },
      brandLogos: false
    }
  },
  tu: {
    key: 'tu',
    salesChannel: 'tu',
    canonicalBase: 'https://tuclothing.sainsburys.co.uk',
    faviconPath: '/i/Argos/TuFavicon',
    tealiumPath: 'argos/tuc/qa',
    theme: Themes.TuTheme,
    vocab: TuVocab,
    bolt: {
      namespace: 'bolt-tu',
      stylesheet: `//www.argos.co.uk/assets/bolt2/${boltUiVersion}/bolt-tu.min.css`
    },
    features: {
      taxonomy: {
        vocabId: 'PROD Tu Navigation'
      },
      addToTrolley: {
        modal: {
          enabled: false,
          hideExtras: false,
          hideCategories: false
        }
      },
      backInStock: {
        enabled: false
      },
      bestSellers: {
        enabled: false
      },
      sponsoredProducts: {
        enabled: false
      },
      wishlist: {
        enabled: false
      },
      productList: {
        forceClothingTemplate: true,
        forceEnableAltImageHover: true,
        disableComRel: true,
        disableTuLogo: false,
        enableSortbyNew: true,
        sortByRelevance: ['842051', '842050', '842028', '842038', '842041', '842035', '842025', '841891'],
        includeRelevancyNewness: true
      },
      productCard: {
        colorSwatchInline: false,
        colorSwatchAlwaysVisible: true,
        colorSwatchMaxVariations: 10,
        colorSwatchSize: 'small',
        turnOffCta: true,
        showClearanceBadge: false,
        enableValueMessaging: true,
        disableClickPR: true
      },
      listerTools: {
        hideMobileResultsCount: false,
        offsetSelector: '[data-module-name="Header"] header',
        safeZone: 205,
        reverseScrollBehaviour: true
      },
      seoFooter: {
        hideOnAppliedFilters: false
      },
      categoryList: {
        contentAreaNav: false
      },
      filterPanel: {
        transposeCategories: ['798600']
      },
      filterPills: {
        enabled: true,
        filters: {
          browse: ['size'],
          search: ['department', 'size'],
          default: []
        }
      },
      goInStoreWidget: {
        enabled: false
      },
      availability: {
        enabled: true,
        chunkSize: 6,
        hasLocalisationHeader: false,
        webChannel: 'web_plp_tu',
        radius: {
          radiusDefaultValue: 10,
          radiusOptions: [],
          radiusLocalStorageKey: null
        }
      },
      availabilityTooltip: {
        enabled: false
      },
      refinedTitlePage: {
        enabled: true,
        maxRefinements: 3,
        refinementTypes: ['sleeve length', 'price', 'type', 'style', 'brands', 'size'],
        departments: ['Women', 'Men', 'Boys', 'Girls', 'Baby']
      },
      citrus: {
        banners: {
          enabled: false
        },
        gridBanners: {
          enabled: false
        }
      },
      similarAi: {
        enabled: true,
        routes: ['/sd/', '/browse/']
      },
      brandLogos: true
    }
  }
}
